import React, { useEffect, useState } from 'react'

const SHURIKEN = '/assets/images/shuriken.png'

export default function EquipmentMannequinFigure({ char = {}, slug = '' }) {
  const slugCandidate = slug ? `/assets/images/${slug}.png` : ''
  const primary = (char?.portrait && String(char.portrait).trim()) || ''
  const name = String(char?.name || '').trim()
  const clan = String(char?.clan || '').trim()
  const displayName = clan ? `${clan} ${name}` : name || 'Sin nombre'

  const [src, setSrc] = useState(primary || slugCandidate || SHURIKEN)

  useEffect(() => {
    setSrc(primary || slugCandidate || SHURIKEN)
  }, [primary, slugCandidate])

  const handleImgError = () => {
    if (src !== SHURIKEN) setSrc(SHURIKEN)
  }

  return (
    <div className="char-equipo__portrait" aria-label="Retrato del personaje">
      <div className="char-portrait-wrap">
        <div className="char-portrait-frame char-equipo__portrait-frame">
          <div className="char-portrait-frame__inner">
            <img src={src} alt={displayName} loading="lazy" onError={handleImgError} />
            <div className="char-portrait-frame__vignette" aria-hidden="true" />
          </div>
          <span className="char-portrait-corner char-portrait-corner--tl" aria-hidden="true" />
          <span className="char-portrait-corner char-portrait-corner--tr" aria-hidden="true" />
          <span className="char-portrait-corner char-portrait-corner--bl" aria-hidden="true" />
          <span className="char-portrait-corner char-portrait-corner--br" aria-hidden="true" />
        </div>
      </div>
    </div>
  )
}
